import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IInquiry } from '@webapp/core/interfaces';
import { Observable } from 'rxjs';
import { UrlConstantsService } from './url-constants.service';


@Injectable({ providedIn: 'root' })
export class PublicInquiryService {
  constructor(protected _http: HttpClient, protected _urls: UrlConstantsService) {
  }

  getMyRatings(companyUUID: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  createRating(formValue: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  createEnquiry(formValue: any) {
    return this._http.post<IInquiry>(this._urls.PUBLIC_INQUIRIES, formValue)
  }

  /**
   * Read back a submitted inquiry. Answers 410 once its correction window has
   * closed, which is also the moment the data leaves us for the partners.
   */
  getInquiry(uuid: string) {
    return this._http.get<IInquiry>(`${this._urls.PUBLIC_INQUIRIES}/${uuid}`)
  }

  /** Correct a submitted inquiry. Also 410 once the window has closed. */
  updateInquiry(uuid: string, formValue: any) {
    return this._http.patch<IInquiry>(`${this._urls.PUBLIC_INQUIRIES}/${uuid}`, formValue)
  }
}
